import React, {useEffect, useState} from 'react';
import {withRouter} from "react-router-dom";
import {makeStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import CardMedia from "@material-ui/core/CardMedia";
import logoImg from "../assets/logo.png";
import AuthForm from "../components/auth/AuthForm";
import PasswordChangeForm from "../components/auth/PasswordChangeForm";
import ForgotPasswordForm from "../components/auth/ForgotPasswordForm";
import KognrOpenForm from "../components/auth/KognrOpenForm";
import Typography from "@material-ui/core/Typography";


const useStyles = makeStyles(theme => ({
    mainLayout: {
        alignItems: 'center',
        backgroundColor: 'transparent',
        padding: '20px',
        [theme.breakpoints.up(600 + theme.spacing(2))]: {
            alignItems: 'center',
            // backgroundColor: 'rgba(5, 5, 5, 0.2)',
            padding: '20px 80px',
            borderRadius: '15px',
        }
    },
    logo: {
        position: 'absolute',
        bottom: '11%',
        right: '16%',
        height: 80,
        width: 76,
        [theme.breakpoints.up(600 + theme.spacing(2))]: {
            position: 'absolute',
            bottom: '9%',
            right: '6%',
            height: 106,
            width: 100
        }
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center'
    },
    button: {
        marginTop: theme.spacing(10),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        border: '1px solid #ffffff',
        backgroundColor: "transparent",
        padding: '5px 28px',
        height: 41,
        fontFamily: 'Noto Sans KR',
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontSize: "14px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        },
        [theme.breakpoints.up(600 + theme.spacing(2))]: {
            marginTop: theme.spacing(15),
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            border: '1px solid #ffffff',
            backgroundColor: "transparent",
            padding: '5px 35px',
            height: 45,
            fontFamily: 'Noto Sans KR',
            fontWeight: 'bold',
            fontStyle: 'normal',
            fontSize: "17px",
            color: 'white',
            '&:hover': {
                backgroundColor: '#767676',
                color: '#ffffff'
            }
        }
    },
    paper: {
        margin: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
}));

const IntroForm = ({ stdYear }) => {
    const [step, setStep] = useState("LOGIN");
    const [agentMessage, setAgentMessage] = useState(false);
    const classes = useStyles();

    useEffect(() => {
        const agent = window.navigator.userAgent.toLowerCase();
        const isPasswdChange = localStorage.getItem("IS_PASSWD_CHANGE") || "0";

        if (agent.indexOf("trident") > -1) {
            setAgentMessage(true);
        }

        if (isPasswdChange === "1") {
            setStep("CHANGE");
        }
    }, []);

    const comp = () => {
        switch (step) {
            case "LOGIN":
                return (
                    <AuthForm stdYear={stdYear} setStep={setStep}/>
                );
            case "CHANGE":
                return (
                    <PasswordChangeForm stdYear={stdYear} />
                );
            case "FORGOT":
                return (
                    <ForgotPasswordForm stdYear={stdYear} setStep={setStep} />
                );
            case "OPEN":
                return (
                    <KognrOpenForm />
                );
            default:
                break;
        }
    }

    return (
        <>
            <Grid container
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  className={classes.mainLayout}
            >
                <CardMedia
                    className={classes.logo}
                    image={logoImg}
                />
                <br/>
                <span className="intro-title">
                    {stdYear}
                </span>
                <span className="intro-title-2">
                    귀속 종합소득세
                </span>
                <span className="intro-title-3">
                    신고 질문지
                </span>
                {agentMessage &&
                    <>
                        <br/>
                        <Typography variant="h6" gutterBottom component="div" style={{color: '#FF8C00'}}>
                            IE에서는 정상적으로 동작하지 않습니다.
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" style={{color: '#FF8C00'}}>
                            권장 브라우저(크롬, 엣지)를 이용해 주시기 바랍니다.
                        </Typography>
                    </>
                }
                {!agentMessage && comp()}
            </Grid>
        </>
    );
};

export default withRouter(IntroForm);
